import {RouteConfig} from "vue-router";
import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import {ifAuthenticated} from "@/routes/access";

import Dashboard from "@/pages/Pages/Dashboard.vue";
import UserProfile from "@/pages/Pages/UserProfile/UserProfile.vue";

const profileMenu: RouteConfig = {
    path: "/",
    component: DashboardLayout,
    beforeEnter: ifAuthenticated,
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        component: Dashboard,
        meta: {
          icon: "home",
          msgKey: 'menu.item.home'
        }
      },
      {
        path: "/user/profile",
        name: "user_profile",
        component: UserProfile,
        meta: {
          icon: "perm_identity",
          msgKey: 'menu.item.profile.personal.data'
        }
      },
    ]
}

export default profileMenu;
